'use client';
import AppLayout from '@/components/AppLayout';
import CampaignDetailView from './components/CampaignDetailView';

export default function CampaignDetailPage() {
  return (
    <AppLayout portalName="Investor Portal" portalRole="investor">
      <CampaignDetailView />
    </AppLayout>
  );
}
